import styled from '@emotion/styled'
import { memo } from 'react'

const VideoPosterRoot = styled('div')({
    justifyContent: 'center',
    position: 'relative',
    alignItems: 'center',
    overflow: 'hidden',
    flexBasis: '100%',
    display: 'flex',
    height: '100%',
    width: '100%',
    flexGrow: 1,
})

const VideoPoster = memo(() => {
    return <VideoPosterRoot />
})

export default VideoPoster
